import { STORE_RELATIONS_FALLBACK_TEXT } from '../constants/storeConstants'
import { resolveStoreRelationSecondaryStatus } from '../helpers/storeRelationStatusUtils'

const normalizeDisplayValue = (value) => {
  return typeof value === 'string' ? value.trim() : value
}

export const resolveStoreRelationText = (
  value,
  fallback = STORE_RELATIONS_FALLBACK_TEXT
) => {
  const normalizedValue = normalizeDisplayValue(value)

  if (typeof normalizedValue === 'string') {
    return normalizedValue || fallback
  }

  return normalizedValue ?? fallback
}

export const formatStoreRelationName = (name) => {
  return resolveStoreRelationText(name)
}

export const formatStoreRelationSalesmanLabel = (salesman) => {
  if (!salesman) return STORE_RELATIONS_FALLBACK_TEXT

  const dbRef = resolveStoreRelationText(salesman?.db_ref)
  const name = resolveStoreRelationText(salesman?.name)

  return `${dbRef} - ${name}`
}

export const formatStoreRelationClientLabel = (client) => {
  if (!client) return STORE_RELATIONS_FALLBACK_TEXT

  const dbRef = resolveStoreRelationText(client?.db_ref)
  const name = resolveStoreRelationText(client?.name)

  return `${dbRef} - ${name}`
}

export const getStoreRelationSalesmanKey = (salesman, fallbackValue = null) => {
  return salesman?.id || salesman?.db_ref || salesman?.name || fallbackValue
}

export const getStoreRelationRelationSalesmanKey = (relation, fallbackValue = null) => {
  return getStoreRelationSalesmanKey(relation?.salesman, relation?.id || fallbackValue)
}

export const getStoreRelationModelKey = (model, fallbackValue = null) => {
  return (
    model?.client_principal?.id ||
    model?.client_configuration?.id ||
    model?.client?.id ||
    fallbackValue
  )
}

export const dedupeStoreRelationUsersBySalesmanAndStatus = (relations = []) => {
  const uniqueMap = new Map()

  relations.forEach((relation, index) => {
    const salesman = relation?.salesman
    if (!salesman) return

    const key = `${getStoreRelationRelationSalesmanKey(relation, `salesman-${index}`)}-${resolveStoreRelationSecondaryStatus(relation)}`

    if (!uniqueMap.has(key)) {
      uniqueMap.set(key, relation)
    }
  })

  return Array.from(uniqueMap.values())
}

export const buildStoreRelationSalesmanOption = (salesman, fallbackId = null) => {
  const dbRef = typeof salesman?.db_ref === 'string' ? salesman.db_ref.trim() : ''
  const name = typeof salesman?.name === 'string' ? salesman.name.trim() : ''

  return {
    id: salesman?.id || dbRef || name || fallbackId,
    db_ref: dbRef,
    name,
    label: [dbRef, name].filter(Boolean).join(' - '),
    raw: salesman || null
  }
}

export const mergeUniqueStoreRelationSalesmanOptions = (...groups) => {
  const seenKeys = new Set()

  return groups
    .flat()
    .filter(Boolean)
    .filter((option) => {
      const optionKey = option?.db_ref?.trim() || option?.id || option?.name?.trim()

      if (!optionKey || seenKeys.has(optionKey)) return false

      seenKeys.add(optionKey)
      return true
    })
}
